<template>
  <div>
    <div class="page page__wrapper wrapper">
      <header class="header header">
        <div class="header__logo-container header__logo-container--login">
          <div class="header__logo header__logo--login">
            <router-link to="/"><img src="/images/fuel-logo.png" alt="Fuel Member Portal" class="header__logo-img" /></router-link>
          </div>
        </div>
      </header>
      <main>
        <article class="page-login__container">
          <div class="page-login__frame-intro">
            <div id="browser-alert" class="page-login__browser-alert">
              <i class="browser-alert__icon fa fa-eye-slash fa-lg"></i>
              <div class="browser-alert__content">
                <div class="browser-alert__content--header">THIS WEBSITE IS NOT OPTIMIZED FOR YOUR BROWSER!</div>
                <div class="browser-alert__content--text">For the best experience, please use Google Chrome.</div>
              </div>
              <div class="browser-alert__link-container">
                <a href="https://www.google.com/chrome/" class="browser-alert__link">
                  <img class="browser-alert__chrome-icon" src="/images/chrome.png"/>GET CHROME
                </a>
              </div>
            </div>
            <div class="container">
              <div class="row">
                <div class="col-xs-12 h-center-align">
                  <SystemMessage></SystemMessage>
                </div>
              </div>
              <div class="row" v-if="header">
                <div class="col-sm-12 h-center-align">
                  <div class="page-login__heading">Welcome to the Fuel Member Portal</div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 h-center-align">
                  <component v-bind:is="componentName"></component>
                </div>
              </div>
            </div>
            <div class="page-login__footer">
              Copyright &copy; {{ currentYear }} Fuel Medical Group. All Rights Reserved.
            </div>
          </div>
        </article>
      </main>
    </div>
  </div>
</template>

<script>
  import SystemMessage from '../components/layout/SystemMessage.vue';
  import AuthorizeForm from '../components/layout/AuthorizeForm.vue';
  import LoginForm from '../components/layout/LoginForm.vue';
  import VerifyForm from '../components/layout/VerifyForm.vue';
  import ResetForm from '../components/layout/ResetForm.vue';

  export default {
    name: 'LoginLayout',
    components: {
      SystemMessage,
      AuthorizeForm,
      LoginForm,
      VerifyForm,
      ResetForm,
    },
    props: {
      componentName: {
        type: String,
        default: 'LoginForm',
      },
      systemMessage: {
        type: String,
        default: '',
      },
      header: {
        type: Boolean,
        default: true,
      },
    },
    computed: {
      currentYear() {
        return (new Date().getFullYear());
      },
    },
  }
</script>
